import {TextField} from '@mui/material';
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import React from 'react'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';


const EntryDate = ({label, value, setValue, disabled}) => {

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    inputFormat="DD/MM/YYYY"
                    disabled={disabled}
                    value={value}
                    onChange={(newValue) => {
                        setValue(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} InputProps={
                        disabled && {
                            style: {
                                color: 'black !important',
                                backgroundColor: 'hsl(0, 0%, 95%)',
                            },
                        }
                    }
                                                        label={label || `Entry Date`} size="small"
                                                        fullWidth/>}
                />
            </LocalizationProvider>
        </>
    )
}

export default EntryDate